$(function() {
    // Mobile vehicle selector.
    var $mobileVehicleList = $('#mobile-vstep-list');
    var $mobileVehicleForm = $('#mobile-vehicle-selector-form');
    var $mobileVehicleSelector = $('#mobile-vehicle-selector');
    var mobileVehicleDimension = '.vehicle-selector-dimension-header';
    var mobileVehicleOptions = '.vehicle-selector-dimension-options';

    // When they click on a vehicle step (make, series, etc.)
    $mobileVehicleSelector.on('click', mobileVehicleDimension, function(e) {
        e.preventDefault();
        const expanded = Boolean(e.target.getAttribute('aria-expanded') == 'true');
        e.target.setAttribute('aria-expanded', !expanded);
    });

    $mobileVehicleSelector.on('click', `${mobileVehicleOptions} li`, function(e) {
        e.preventDefault();
        
        var $option = $(this);
        var $parentLi = $option.parents('.vstep-wrapper');
        
        // See what option they clicked and what step it belongs to.
        var vstep = $option.data('step');
        var value = $option.data('key');
        
        // Hide the form.
        $mobileVehicleForm.addClass('d-none');
        
        // Slide this vstep up now that they chose an option.
        $parentLi.find(mobileVehicleDimension).trigger('click');
        // Change the label name of it.
        $parentLi.find(mobileVehicleDimension + ' > span').html($option.html());
        
        // Remove every other step after this one.
        var $removeVSteps = $parentLi.nextAll();
        
        // Remove these from the form.
        $.each($removeVSteps, function(index, step) {
            var $step = $(step);
            
            VehicleSelector.removeStep($step.data('vstep'));
            
            // Now remove the actual wrapper.
            $step.remove();
        });
        
        // Remove the input for this step (but not the wrapper)
        VehicleSelector.removeStep(vstep);
        
        // Add thie new value for this step.
        VehicleSelector.addStep(vstep, value);
        
        // Make the request.
        VehicleSelector.getNextStep(function(data) {
            buildStepList($mobileVehicleList, data);
        });
    });

    /**
     * Submit vehicle selector form.
     *
     * @param DOMElement form
     *
     * @return void
     */
    function submitVehicleForm(form) {
        var steps = [];
        
        // Put the steps in a format the template can understand (key and value don't seem to work for some reason)
        $.each(VehicleSelector.getSteps(), function(step, value) {
            steps.push({
                key: step,
                value: value
            });
        });
        
        form.find('.form-fields').html(Jemplate.process('includes/partials/vehicle-hidden-form-steps.html', {
            steps: steps
        }));
        
        form.submit();
    }
    
    /**
     * Reset vehicle selector form.
     *
     * @param DOMElement form
     * 
     * @return void
     */
    function resetVehicleForm(form) {
        // Remove hidden input fields
        form.find('.form-fields').html('');
    }
    
    /**
     * Element to append the new list to.
     *
     * @param DOMElement element
     * @param object     data
     *
     * @return void
     */
    function buildStepList(element, data) {
        if (data.length === 0) {
            // End of vehicle selection options so let's submit the form.
            submitVehicleForm($mobileVehicleForm);
            return;
        }
        
        // Append data to li elements.
        var lastStep = data[data.length - 1].key; // Need this to store the last select for event trigger if it's the last default option.
        $.each(data, function(index, step) {
            if (step.options.length == 0) {
                // There are no options except for the label so don't show this one.
                return true;
            }
            
            // Build dropdown
            var templateOptions = {
                step: step.key.split('_')[1],
                label: step.label,
                options: step.options,
                isDisabled: false,
                expanded: true
            };
            
            // Let's check if this step only has one options.
            if (step.options.length == 1) {
                // Set a default value!
                templateOptions.label = step.options[0].label;
                templateOptions.value = step.options[0].val;
                templateOptions.options = []; // Remove options since it only has one
                templateOptions.isDisabled = true;
                
                // Put these in the form.
                VehicleSelector.addStep(templateOptions.step, templateOptions.value);
            }
            
            var $liElement = $(Jemplate.process('includes/partials/vehicle-selector-li.html', templateOptions));
            element.append($liElement);
            
            // If no options, trigger click event on this element.
            if (templateOptions.options.length == 0) {
                $liElement.find(mobileVehicleDimension).trigger('click');
            }
            
            // If it's the last select box in the form and is disabled, trigger the change event.
            if (step.key === lastStep && templateOptions.isDisabled) {
                // Build steps object.
                VehicleSelector.addStep(templateOptions.step, templateOptions.value);
                
                // Make the request.
                VehicleSelector.getNextStep(function(data) {
                    buildStepList(element, data);
                });
            }
        });

        if ( VehicleSelector.stepsToSelect.length ) {
            var nextStepValue = VehicleSelector.stepsToSelect.shift();
            element.find( 'li' ).each( ( i, option ) => {
                var $option = $( option );
                if ( $option.text() === nextStepValue.toString() ) {
                    $option.click();
                    return false;
                }
            } );
        }
    }
});
